import type { ComponentType } from "react";
import { FileText, Link2 } from "lucide-react";
import { GOOGLE_DRIVE_MARK_ICONS } from "@/components/ui/google-drive-mark-icons";
import { googleDriveMarkKind, googleDriveTypeLabel } from "@/lib/google-drive-labels";
import type { SessionMaterial } from "@/lib/api/sessionPortal";

/**
 * A row's kind, as an icon. A lookup over what the resource IS: a Drive file
 * takes Drive's mark for its kind, so a Google item is known at a glance.
 */
export function materialIcon(material: SessionMaterial): ComponentType<{ className?: string; strokeWidth?: number }> {
  if (material.google_drive_mime_type?.trim()) return GOOGLE_DRIVE_MARK_ICONS[googleDriveMarkKind(material.google_drive_mime_type, material.file_url)];
  if (/link|url/i.test(material.material_type)) return Link2;
  return FileText;
}

/** A row's kind, in words: the Drive type when the material lives on Drive. */
export function materialKind(material: SessionMaterial): string | null {
  return googleDriveTypeLabel(material.google_drive_mime_type)
    ?? (/link|url/i.test(material.material_type) ? "Link" : null);
}
